<template>
  <div
    class="layout-search-field"
    :class="[
      {
        'page-hina': isHina,
        'page-jps': isJps,
      },
    ]"
  >
    <div
      v-if="$slots.tabList"
      class="layout-search-field-tab-list"
    >
      <slot name="tabList" />
    </div>

    <div
      v-show="showValue"
      class="layout-search-field-flex"
    >
      <div
        v-if="$slots.default || $slots.header"
        class="layout-search-field-contents"
        :class="{
          'type-normal': displayVariant === 'normal',
          'type-list': displayVariant === 'list',
        }"
      >
        <div
          v-if="$slots.header"
          class="layout-search-field-header field-contents"
        >
          <slot name="header" />
        </div>

        <div
          v-if="$slots.default"
          class="layout-search-field-body field-contents"
          :class="bodyHasBgColor && 'field-contents-body-bg'"
        >
          <slot />
        </div>
      </div>

      <div
        v-if="$slots.nav || $slots.options"
        class="layout-search-field-nav"
      >
        <div
          v-if="$slots.nav"
          class="nav-item"
        >
          <slot name="nav" />
        </div>

        <div
          v-if="$slots.options"
          class="nav-options"
        >
          <slot name="options" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  displayVariant?: 'list' | 'normal'
  bodyHasBgColor?: boolean
  isShow?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  displayVariant: 'normal',
  isShow: true,
})
const { isHina, isJps } = useServiceType()

const showValue = computed(() => props.isShow)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.layout-search-field {
  width: 100%;
}

.layout-search-field-flex {
  display: flex;
  gap: 0;
  flex-direction: column;
}

.layout-search-field-contents {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: $white;

  .field-contents {
    padding: 0rem 2rem 0.75rem 0.75rem;

    &:first-child {
      padding-top: 0.75rem;
    }
  }

  .field-contents-body-bg {
    background: $jps-gray-50;
    padding-top: 0.75rem;
  }
}

.type-normal {
  .layout-search-field-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    background-color: $white;
  }
}

.type-list {
  .layout-search-field-body {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    background-color: $white;
  }
}

.layout-search-field-nav {
  background: $jps-gray-50;
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  width: 100%;
  flex-wrap: wrap;

  :deep(button),
  :deep(a) {
    font-size: 0.875rem;
    display: flex;
    align-items: center;
  }

  .nav-item,
  .nav-options {
    display: flex;
    align-items: center;
  }

  .nav-options {
    flex-shrink: 0;
    margin-left: auto;
    margin-right: 0;
    line-height: 1;
  }
}

.page-hina {
  .layout-search-field-nav {
    border-top: 1px solid $jps-gray-100;
    background: $hina-background-cream;
  }
}
</style>
